// Rivio custom: FAQ accordion handler

// Gebruik check voor bestaande handler om duplicaten te voorkomen bij meerdere FAQ secties
(function () {
  if (window.faqHandlerAdded) return;

  const handleFaqClick = (e) => {
    const question = e.target.closest('.faq-question');
    if (!question) return;

    const item = question.closest('.faq-item');
    if (!item) return;

    const isActive = item.classList.toggle('active');

    question.setAttribute('aria-expanded', isActive);
  };

  document.addEventListener('click', handleFaqClick);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      const question = e.target.closest('.faq-question');
      if (question) {
        e.preventDefault();
        question.click();
      }
    }
  });

  window.faqHandlerAdded = true;
})();

